// extracted by mini-css-extract-plugin
export default {"blue":"var(--blue)","link":"PC7CQdYaTT_BP17Wii53"};